import { MyApp } from '../apps/types/myAppTypes';

export enum CatalogQueryType {
  Component = 'Component',
  API = 'API',
  Device = 'Device',
  TechDocs = 'TechDocs',
  Application = 'Application',
}

export type CatalogStandardMapping =
  | {
      queryType: CatalogQueryType.API;
      data: ResourceCatalogComponentApiPaged;
    }
  | {
      queryType: CatalogQueryType.Device;
      data: ResourceCatalogDevicePaged;
    }
  | {
      queryType: CatalogQueryType.Component;
      data: ResourceCatalogComponentPaged;
    }
  | {
      queryType: CatalogQueryType.Application;
      data: ResourceCatalogApplicationPaged;
    };

export type CatalogSearchResultItem = {
  expandable: boolean;
  name: string;
  id: string | number;
  title?: string;
  lifecycle?: string;
  href?: string;
  applicationsPaged?: ApplicationPaged;
  applications?: ResourceCatalogApplication[];
  ownerOrg?: string;
} & (
  | {
      type: CatalogQueryType.API;
      item: ResourceCatalogComponentApi;
    }
  | {
      type: CatalogQueryType.Device;
      item: ResourceCatalogDevice;
    }
  | {
      type: CatalogQueryType.Component;
      item: ResourceCatalogComponent;
    }
  | {
      type: CatalogQueryType.TechDocs;
      item: ResourceCatalogComponent;
    }
  | {
      type: CatalogQueryType.Application;
      item: ResourceCatalogApplication;
    }
);

export interface ResourceCatalogComponentPaged {
  resources: {
    componentsPaged: {
      components: ResourceCatalogComponent[];
      totalCount: number;
    };
  };
}

export interface ResourceCatalogComponent {
  id: number;
  name: string;
  title: string;
  type: string;
  description: string;
  lifecycle: string;
  techDocsRef: string;
  source: string;
  sourceLocationUrl: string;
  applicationsPaged: ApplicationPaged;
  scmSlug: string;
  devHubOwner: string;
}

export interface ResourceCatalogComponentApiPaged {
  resources: {
    componentApisPaged: {
      componentApis: ResourceCatalogComponentApi[];
      totalCount: number;
    };
  };
}

export interface ResourceCatalogComponentApi {
  id: number;
  name: string;
  title: string;
  type: string;
  description: string;
  lifecycle: string;
  definitionRef: string;
  source: string;
  sourceLocationUrl: string;
  scmSource: string;
  scmSlug: string;
  devHubOwner: string;
  applicationsPaged: ApplicationPaged;
}

export interface ResourceCatalogDevicePaged {
  resources: {
    devicesPaged: {
      devices: ResourceCatalogDevice[];
      totalCount: number;
    };
  };
}

export interface ResourceCatalogDevice {
  deviceId: string;
  hostname: string;
  type: string;
  ipAddress: string;
  fqdn: string;
  environment: string;
  location: string;
  serialNumber: string;
  tier: string;
  href: string;
  osInfo: {
    make: string;
    name: string;
    edition: string;
    release: string;
    version: string;
  };
  applications: ApplicationPaged;
  attributes: {
    id: number;
    deviceId: number;
    key: string;
    value: string;
  }[];
  tags: string[];
  hardening: {
    deviceId: number;
    patcherJobId: number;
    state: string;
    hbaWwn: string;
    osPackageRepo: string;
    osPatchMethod: string;
    osPatchDate: string;
    osHardenVersion: string;
    osHardenDate: string;
    osPatchVersion: string;
    osImageVersion: string;
    osStandardVersion: string;
    osStandardDate: string;
  };
}

export interface ResourceCatalogApplicationPaged {
  resources: {
    applicationsPaged: {
      applications: ResourceCatalogApplication[];
      totalCount: number;
    };
  };
}

export interface ApplicationPaged {
  applications: ResourceCatalogApplication[];
  totalCount: number;
}

export interface ResourceCatalogApplication extends MyApp {}

export interface CatalogSearchResultData {
  items: CatalogSearchResultItem[];
  totalCount: number;
}

export type FieldRenderer = (
  col: ColumnDefinition,
  index: number,
) => JSX.Element;
export type ColumnDefinition = {
  field: string;
  header: string;
  width: string;
  renderer?: FieldRenderer;
};

export enum OwnerFilterType {
  Owned = 'Owned',
  All = 'All',
  Starred = 'Starred',
}
